<script setup>
import AppCard from '../components/layouts/AppCard.vue';
import AppPreviewCard from '../components/layouts/AppPreviewCard.vue';
import { useAuthStore, useContractStore } from '../stores';
import { useRouter } from 'vue-router'

const router = useRouter()

const authStore = useAuthStore();
const contractStore = useContractStore();
</script>

<template>
    <div class="mx-2">
        <div class="grid grid-cols-1 md:grid-cols-3 justify-center content-start">
            <!-- TODO: pull back button card into a separate component -->
            <AppCard :back-button="true" header="" body="" />
            <!-- <div :class="`font-bold basis-4/12 text-[--color-powder-4]`">
                {{ "contract.title" }}
            </div> -->
            <AppCard header="Open Contracts" v-if="authStore.currentChild">
                <div class="max-h-24 overflow-y-auto">
                    <!-- <div > -->
                    <div v-for="contract in authStore.currentChild.contracts" :key="`child-contract-${contract.id}`" class="">
                        <!-- @clicked.once="router.push(`/contracts/${contract.id}`)" -->
                        <AppPreviewCard 
                            >
                            <div class="flex flex-row justify-stretch content-center max-w-prose max-h-12">
                                <svg class="w-6 h-6 rounded-full mr-2"
                                    :class="'bg-[--color-powder-4]'" aria-hidden="true"
                                    xmlns="http://www.w3.org/2000/svg" fill="none" viewBox="0 0 20 20">
                                </svg>
                                <div class="basis-11/12 text-sm truncate line-clamp-2">{{ contract.title }}</div>
                            </div>
                        </AppPreviewCard>
                    </div>
                    <!-- </div> -->
                </div>
            </AppCard>
            <!-- <AppCard :header="`${authStore.currentChild.contracts[0].tile}`" body="" v-if="authStore.currentChild"/> -->
        </div>
    </div>
</template>